/* Zoom toggle for the material badge's spec sheet overlay.

   Opening and closing is the theme's own <basic-modal>, wired by aria-controls;
   nothing here is needed for that. This only handles legibility: the sheet is a
   dense 4:5 poster, and fitted to a phone screen its body copy lands around six
   pixels tall. Clicking the image switches it to its served width so the panel
   pans, and clicking again returns it to fitted.

   Delegated from the document so a badge re-rendered by a variant change keeps
   working without re-binding. */
(function () {
  var ZOOMED = 'is-zoomed';
  var TRIGGER = '.material-badge--interactive';

  /* Was the overlay opened by pointer or by keyboard?

     On close the theme's removeTrapFocus calls .focus() on the trigger, which
     is right for keyboard users returning to where they were. But Safari counts
     programmatic focus as keyboard focus, so :focus-visible matches and
     theme.css's global outline leaves a ring around the badge after a plain
     tap. Chrome does not, which is why this only shows up on some browsers.

     So: remember how it was opened, and drop focus afterwards only for pointer
     users, who had no visible focus to return to anyway. */
  var openedByPointer = false;

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.target.closest && event.target.closest(TRIGGER)) openedByPointer = true;
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      if (event.target.closest && event.target.closest(TRIGGER)) openedByPointer = false;
    },
    true
  );

  document.addEventListener('click', function (event) {
    var image = event.target.closest('.spec-sheet__image');
    if (!image) return;

    var body = image.closest('[data-spec-sheet-body]');
    if (!body) return;

    var zoomingIn = !body.classList.contains(ZOOMED);

    /* Read the click against the fitted image before the class changes its size. */
    var before = image.getBoundingClientRect();
    var ratioX = (event.clientX - before.left) / before.width;
    var ratioY = (event.clientY - before.top) / before.height;

    body.classList.toggle(ZOOMED, zoomingIn);

    /* The img carries a responsive srcset whose sizes describe the fitted view,
       so on a phone the browser has picked a ~350px candidate. Zooming into that
       would just magnify a blurry copy. Restating sizes as the width the image
       now actually occupies makes the browser re-run source selection and pull
       the full rendition, and only for shoppers who ask for it. */
    if (zoomingIn) {
      if (!image.dataset.fittedSizes) image.dataset.fittedSizes = image.sizes || '';
      image.sizes = image.offsetWidth + 'px';
    } else {
      if (image.dataset.fittedSizes) image.sizes = image.dataset.fittedSizes;
      body.scrollTo(0, 0);
      return;
    }

    /* Zooming from a fitted view should land on the point that was clicked,
       otherwise the panel jumps to the top-left corner of a sheet several times
       the size of the viewport. */
    body.scrollTo({
      left: image.offsetWidth * ratioX - body.clientWidth / 2,
      top: image.offsetHeight * ratioY - body.clientHeight / 2,
    });
  });

  document.addEventListener('modal:handleAfterHide', function (event) {
    var modal = event.target;
    var body = modal.querySelector && modal.querySelector('[data-spec-sheet-body]');
    if (!body) return;

    /* A panel left zoomed would reopen mid-sheet, which reads as broken. */
    var image = body.querySelector('.spec-sheet__image');
    if (image && image.dataset.fittedSizes) image.sizes = image.dataset.fittedSizes;
    body.classList.remove(ZOOMED);
    body.scrollTo(0, 0);

    if (!openedByPointer) return;
    openedByPointer = false;

    /* The theme restores focus from inside a setTimeout queued just before this
       event fired, so queue behind it rather than racing it. */
    setTimeout(function () {
      var trigger = document.querySelector(TRIGGER + '[aria-controls="' + modal.id + '"]');
      if (trigger && document.activeElement === trigger) trigger.blur();
    });
  });
})();
